import type { JSONSchema } from '@carboncopyco/editor-utils';
import {
  MinusCircleOutlineIcon,
  PlusCircleOutlineIcon,
} from '@carboncopyco/icons';
import { useBoolean } from 'ahooks';
import { ActionIcon } from './ActionIcon';

export interface JsonTreeLabelProps {
  text: string;
  jsonSchema: JSONSchema;
  hasFormField?: boolean;
  onAddToForm: () => void;
  onRemoveFromForm: () => void;
}

const isTypeSupported = (jsonSchema: JSONSchema = {}) => {
  const { type, items } = jsonSchema;

  // Only Arrays of objects are supported.
  const isNotArrayOfObjects = type === 'array' && items?.type !== 'object';

  return isNotArrayOfObjects || type === 'null';
};

export const JsonTreeLabel = ({
  text,
  jsonSchema,
  hasFormField,
  onRemoveFromForm,
  onAddToForm,
}: JsonTreeLabelProps) => {
  const illegalJson = isTypeSupported(jsonSchema);
  const [showIcon, setShowIcon] = useBoolean(false);
  return (
    <span
      className="group flex gap-1"
      onMouseEnter={setShowIcon.setTrue}
      onMouseLeave={setShowIcon.setFalse}
    >
      {text}:
      {showIcon && (
        <span className="gap-1 flex text-ds-primary-300">
          {hasFormField ? (
            <ActionIcon
              iconComponent={MinusCircleOutlineIcon}
              label="Remove from form"
              onClick={onRemoveFromForm}
              disabled={illegalJson}
            />
          ) : (
            <ActionIcon
              iconComponent={PlusCircleOutlineIcon}
              label="Add to form"
              onClick={onAddToForm}
              disabled={illegalJson}
            />
          )}
        </span>
      )}
    </span>
  );
};
